import { APPROVALS } from '@src/graphql/queries/approvals';
import { useActivityFilter } from '@src/hooks/useActivityFilter';
import { useAuth } from '@src/hooks/useAuth';
import { pick } from 'lodash';
import { usePaginatedFetchItems } from 'pe-core-frontend';
import { useMemo } from 'react';
export const useApprovals = ({ clientId, onlyPending, id, workflowTypes, useFilter = true, paymentRequestId, programId, }) => {
    const { currentUser } = useAuth();
    const { filter, setFilter: _setFilter, hasFilter, statuses, } = useActivityFilter({
        key: `approvals-${currentUser?.id}`,
    });
    const spec = useMemo(() => {
        return {
            clientId,
            onlyPending,
            id,
            paymentRequestId,
            programId,
            // Only apply filter values if useFilter is true
            ...(useFilter ? pick(filter, 'dateRange', 'searchText', 'workflowTypes') : {}),
            type: useFilter
                ? filter.type === 'payment_request'
                    ? 'payment_requests'
                    : filter.type === 'program'
                        ? 'programs'
                        : undefined
                : undefined,
            statuses: useFilter ? statuses : [],
            workflowTypes: (workflowTypes || filter.workflowTypes)?.map(type => type.toUpperCase()),
        };
    }, [clientId, onlyPending, filter, statuses, id, workflowTypes, useFilter, paymentRequestId, programId]);
    const { page, setPage, pageSize, setPageSize, total, items, loading, error, find } = usePaginatedFetchItems({
        spec,
        fetchQuery: APPROVALS,
        dataProp: 'approvals',
        initialPageSize: 10,
        skip: !clientId,
    });
    const setFilter = (value) => {
        _setFilter(value);
        setPage(1);
    };
    return {
        approvals: items,
        loading,
        page,
        pageSize,
        setPage,
        setPageSize,
        error,
        total,
        find,
        filter,
        hasFilter,
        setFilter,
    };
};
